module.exports = __webpack_public_path__ + "static/julie.8cf3850f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/index/assets/2x/julie.jpg
// module id = 364
// module chunks = 35783957827783